export default class Backlink {
	constructor() {
        this.backlinks = document.querySelectorAll('[data-back]');

        this.backlinks.forEach(backlink => {
            backlink.addEventListener('click', (e) => {
                e.preventDefault();
                window.history.back();
            });
        })
    }
}
